/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {ThemeColorPath, ThemeColorTextPath} from 'platform/foundation';

export const SALES_LEAGUE_AVATAR_COLOR: ThemeColorPath = 'palettes.blue.20.100';

export const SALES_LEAGUE_AVATAR_TEXT_COLOR: ThemeColorTextPath = 'link';

/** The table row's circle. Matches what platform Avatar calls "small". */
export const SALES_LEAGUE_AVATAR_SIZE = 7;
